import { Link as ChakraLink } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { Link as ReactRouterLink } from "react-router";

type Props = {
  to: string;
  inline?: boolean;
  children?: ReactNode;
};

const Link: React.FC<Props> = ({ to, inline, children }) => (
  <ChakraLink color={inline ? "primary" : undefined} as={ReactRouterLink} to={to}>
    {children}
  </ChakraLink>
);

export { Link };
